import { Link } from "react-router-dom";
import { useT } from "@/i18n/I18nContext";
import { ArrowRight } from "lucide-react";

export const CategoryGrid = ({ categories }) => {
  const { t } = useT();
  return (
    <section className="container-page py-16 sm:py-20">
      <div className="flex items-end justify-between gap-4 mb-8">
        <div>
          <h2 className="font-heading font-bold text-2xl sm:text-3xl lg:text-4xl tracking-tight text-secondary">
            {t("home.categoriesTitle")}
          </h2>
          <p className="text-muted-foreground mt-2 text-base">{t("home.categoriesSubtitle")}</p>
        </div>
        <Link to="/catalogue" data-testid="see-all-categories"
          className="hidden sm:inline-flex items-center gap-1.5 text-primary font-semibold hover:gap-2.5 transition-all">
          {t("common.seeAll")} <ArrowRight className="h-4 w-4" />
        </Link>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 sm:gap-5">
        {categories.map((cat, i) => (
          <Link key={cat.slug} to={`/catalogue?category=${cat.slug}`} data-testid={`category-tile-${cat.slug}`}
            style={{ animationDelay: `${i * 70}ms` }}
            className="group relative rounded-2xl overflow-hidden bg-card border border-border shadow-sm hover:shadow-xl hover:-translate-y-1 transition-[transform,box-shadow] duration-200 animate-fade-up">
            <div className="aspect-square overflow-hidden">
              <img src={cat.image} alt={cat.name} loading="lazy"
                className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-300" />
            </div>
            <div className="p-3.5">
              <h3 className="font-heading font-semibold text-sm sm:text-base text-secondary text-center">
                {t(`categories.${cat.slug}`)}
              </h3>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};
